import { Typography, useMediaQuery } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import QrScanner from 'components/QrScanner';
import { StyledModal, Content, Header } from './QrScannerModal.styles';

interface QrScannerProps {
  isOpen: boolean;
  onClose: () => void;
  onCapture: (code: string) => void;
}

const QrScannerModal = ({ isOpen, onClose, onCapture }: QrScannerProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledModal open={isOpen} onClose={onClose} fullScreen={isMobile}>
      <Content>
        <Header>
          <Typography variant="h1">Scan QR code</Typography>
          <Typography variant="body1">
            Point your camera at the QR code located at the bottom of your receipt.
          </Typography>
        </Header>

        <QrScanner onCapture={onCapture} />
      </Content>
    </StyledModal>
  );
};

export default QrScannerModal;
